import { render, staticRenderFns } from "./SuccessDatalayer.vue?vue&type=template&id=8c225c0c&"
import script from "./SuccessDatalayer.vue?vue&type=script&lang=ts&"
export * from "./SuccessDatalayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports